import Vuetify from '@/plugins/vuetify';

Vuetify.framework.lang.current = (localStorage.getItem('idioma')) ? localStorage.getItem('idioma') : 'pt';

export default {
  processosAfiliados: [],
  filtros: {
    page: 1,
    perPage: 20,
    termo: '',
    referenciaCliente: '',
    codigoStatusEmbarque: [],
    cliente: '',
    eta: '',
    etaCondicao: '',
    dataEmbarque: '',
    dataEmbarqueCondicao: '',
    dataChegada: '',
    dataChegadaCondicao: '',
    order: 'codigoStatusEmbarque',
    direcao: 'DESC',
  },
  campos: {
    referenciaCliente: 'referenciaCliente',
    codigoStatusEmbarque: 'codigoStatusEmbarque',
    cliente: 'cliente',
    tipoProcesso: 'tipoProcesso',
    eta: 'eta',
    dataEmbarque: 'dataEmbarque',
    dataChegada: 'dataChegada',
  },
};
